export const setAuthToken = (token) => {
  return localStorage.setItem("token", token);
};

export const getAuthToken = () => {
  const token = localStorage.getItem("token");
  return token ? token : "";
};

export const setAuthUser = (user) => {
  setAuthToken(user.token);
  return localStorage.setItem("user", JSON.stringify(user));
};

export const getAuthUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};

export const removeAuthToken = () => {
  return localStorage.removeItem("token");
};

export const removeAuthUser = () => {
  removeAuthToken();
  return localStorage.removeItem("user");
};

export const setLoggedUser = (user) => {
  localStorage.setItem("profile", JSON.stringify(user));
  return true;
};
